var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFileDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    fillRule: "nonzero",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5D100",
    fillOpacity: 0.3,
    d: "M40.8 36h14.4v12H40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 57h31.2M60 40.8h10.26M60 46.8h18.635M48 64.2h31.2M48 71.4h31.2M40.8 57h2.4m-2.4 7.2h2.4m-2.4 7.2h2.4m-7.6-42.6h38.8l12 12.48V89.2a2 2 0 0 1-2 2H35.6a2 2 0 0 1-2-2V30.8a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.4 28.8v9.6a2.4 2.4 0 0 0 2.4 2.4h9.6l-12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.2 83.4 3-3 3 3 3-3 3 3 3-3 3 3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFileDoc);
export default __webpack_public_path__ + "static/media/img-file-doc.e5fe180c0b237a3a8655827ba213b616.svg";
export { ForwardRef as ReactComponent };